import { combineReducers } from 'redux';
import { password } from './password.reducer';
import { user } from './user.reducer';

const rootReducer = combineReducers({
    user,
    password
});

export default rootReducer;